import { parse as parser } from '@news12/transformer'

import useDynamicScripts from '../../hooks/useDynamicScripts'
import renderHtml, { sanitizedHtml } from '../utilities/renderHTML'

const Body = ({ body, content }) => {
  const html = parser(content || body?.blocks, false)
  useDynamicScripts({ html, scripts: ['facebook-embed', 'tagboard-embed', 'twitter-embed'] })

  return renderHtml(sanitizedHtml(html))
}

export default Body
